import { capitalize, includes } from "lodash";
export const isEmail = string => includes(string, "@");
export const isAbsoluteHref = (href = "") => /^https?:\/\//i.test(href);
export const capitalizeWithSeparators = string => string.split(/(\s|-)/).map(part => capitalize(part)).join("");
export const addSpaceToUKPostcode = value => value.replace(/\s/g, "").replace(/.{3}$/, " $&");